
function applyBlueTitle() {

  const items = document.querySelectorAll('.blue-title .gm-text');

  items.forEach(function (el) {

    if (el.dataset.processed === "true") return;

    const text = el.textContent.trim();
    if (!text) return;

    const words = text.split(/\s+/);
    if (words.length <= 1) return;

    const lastWord = words.pop();
    const firstPart = words.join(' ');

    el.innerHTML = firstPart + ' <span class="blue">' + lastWord + '</span>';
    el.dataset.processed = "true";
  });
}

// Delay 1000ms after full page load
window.addEventListener('load', function () {
  setTimeout(applyBlueTitle, 1000);
});
